export const styleSheet = () => ({
    container: {
        flex: 1
    }
});
